import { Card, CardContent } from '@/components/ui/card'
import Loader from '@/components/ui/Loader'
import { getCoreRowModel, useReactTable } from '@tanstack/react-table'
import EmptyDatas from 'components/ui/EmptyDatas'
import Table from 'components/ui/my-data-table'
import React, { useMemo } from 'react'
import useSWR from 'swr'
import { create } from 'zustand'
import { columns } from './data-table-column'
import DataTableToolbar from './data-table-toolbar'

export const useAvatarCardTemplatesPage = create((set) => ({
  after: null, // null 表示第1页
  afters: [],
  sizeType: null,
  setSizeType: (sizeType) =>
    set({ sizeType, after: null, afters: [] }),
  goAfter: (nextAfter) =>
    set((state) => {
      if (nextAfter === null) {
        return { after: null, afters: [] }
      }
      const index = state.afters.findIndex((a) => a === nextAfter)
      if (index === -1) {
        return { after: nextAfter, afters: [...state.afters, nextAfter] }
      }
      return { after: nextAfter }
    }),
}))

const AvatarCardTemplates = () => {
  const after = useAvatarCardTemplatesPage((s) => s.after)
  const afters = useAvatarCardTemplatesPage((s) => s.afters)
  const goAfter = useAvatarCardTemplatesPage((s) => s.goAfter)
  const sizeType = useAvatarCardTemplatesPage((s) => s.sizeType)
  const setSizeType = useAvatarCardTemplatesPage((s) => s.setSizeType)
  const limit = 20

  const { data, isLoading, isValidating, mutate } = useSWR([
    '/avatar-card-templates',
    { after, limit, sizeType },
  ])

  // 计算 nextAfter：使用最后一条数据的 id
  const nextAfter = useMemo(() => {
    if (data && data.length === limit) {
      // 如果返回的数据量等于 limit，说明可能还有下一页
      return data[data.length - 1]?.id
    }
    return null
  }, [data, limit])

  const table = useReactTable({
    data: data || [],
    columns,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    getCoreRowModel: getCoreRowModel(),
  })

  if (isLoading || isValidating) return <Loader />
  if (!data || data.length === 0) return <EmptyDatas />

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="mb-2 flex-shrink-0">
        <DataTableToolbar
          mutate={mutate}
          nextAfter={nextAfter}
          after={after}
          goAfter={goAfter}
          afters={afters}
          sizeType={sizeType}
          setSizeType={setSizeType}
        />
      </div>
      <div className="min-h-0 flex-1">
        <Card className="flex h-full flex-col">
          <CardContent className="flex-1 overflow-hidden pb-0 pl-4 pr-0">
            <div className="h-full overflow-auto">
              <Table table={table} />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default AvatarCardTemplates
